import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    educationalStatuses: [],
    educationalStatusesCount: 0,
    educationalStatus: {},
    educationalStatusSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEducationalStatuses(state) {
      return state.educationalStatuses
    },
    getEducationalStatusesCount(state) {
      return state.educationalStatusesCount
    },
    getEducationalStatus(state) {
      return state.educationalStatus
    },
    getEducationalStatusSaveStatus(state) {
      return state.educationalStatusSave
    },
  },
  mutations: {
    EDUCATIONAL_STATUSES_LIST(state, data) {
      state.educationalStatuses = data
    },
    EDUCATIONAL_STATUS_VIEW(state, data) {
      state.educationalStatus = data
    },
    EDUCATIONAL_STATUSES_COUNT(state, data) {
      state.educationalStatusesCount = data
    },
    EDUCATIONAL_STATUS_SAVE(state, data) {
      state.educationalStatuslSave = data
    },
  },
  actions: {
    educationalStatusesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/educational_statuses', data)
        .then(response => {
          commit('EDUCATIONAL_STATUSES_LIST', response.data.data)
          commit('EDUCATIONAL_STATUSES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    educationalStatusView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'educational_statuses.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/educational_statuses', data)
        .then(response => {
          commit('EDUCATIONAL_STATUS_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    educationalStatusSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/educational_statuses/saveData', data)
        .then(response => {
          commit('EDUCATIONAL_STATUS_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
